import { SortingState } from "@tanstack/react-table";
import { DateRange, parseDateRange } from "@/components/shared/date-range-picker-v2";
import { ExploreFiltersValue } from "../explore-filter-menu/ExploreFilterMenu";

export interface ExploreState {
  groupBy?: string;
  dateRange: DateRange;
  parsedDateRange: {
    dateFrom: string;
    dateTo: string;
  };
  filters: ExploreFiltersValue;
  sorting: SortingState;
}

export const defaultState: ExploreState = {
  dateRange: { type: "preset", value: "15d" },
  parsedDateRange: parseDateRange({ type: "preset", value: "15d" }),
  filters: {},
  sorting: [],
};